"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var files_const_1 = require("./files.const");
function isImageExtension(source) {
    if (!lodash_1.isString(source) || !source) {
        return false;
    }
    var extension = source.includes('.') ? lodash_1.last(lodash_1.split(source, '.')) : source;
    return files_const_1.IMAGE_EXTENSIONS.includes(lodash_1.toLower(extension));
}
exports.isImageExtension = isImageExtension;
